import React from 'react'
import { NavLink } from 'react-router-dom'

export default function Edge() {
  return (
    <>
        <div
                                className="tab-pane fade active show"
                                id="pills-tab4"
                                role="tabpanel"
                                aria-labelledby="pills-Tab4-tab"
                              >
                                <div className="row mt-20 ml-10">
                                  <div className="col-xl-12 col-lg-12 col-md-12 ">
                                    <h6 className=" heading">Edge</h6>
                                    <p className="sub-heading">choose style</p>
                                  </div>
                                </div>
                                <div className="row unselect">
                                  <div
                                    className="col-xl-6 col-lg-6 col-md-6 col-sm-12"
                                    style={{ paddingRight: 7 }}
                                  >
                                    <div className="tp-catagori-2__content-box mb-15">
                                      <div className="tp-catagori-2__content plr text-center">
                                        <NavLink to={'/create-print/service'}>
                                        <img
                                          className="w-32"
                                          src="assets/img/blog/edge-1.png"
                                          alt=""
                                        /> 
                                          <h4 className="tp-catagori-2__title text-white">
                                            Thin gallery wrap (0.75)
                                          </h4> 
                                        <p>
                                          Ipsum dolor sit amet,consectetur
                                          adipiscing.
                                        </p>
                                        <p className="box-range">
                                          Starting at +$17.00
                                        </p>
                                        </NavLink>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="col-xl-6 col-lg-6 col-md-6 col-sm-12"
                                    style={{ paddingLeft: 7 }}
                                  >
                                    <div className="tp-catagori-2__content-box mb-15">
                                      <div className="tp-catagori-2__content plr text-center">
                                        <img
                                          className="w-32"
                                          src="assets/img/blog/edge-2.png"
                                          alt=""
                                        />
                                        <h4 className="tp-catagori-2__title text-white">
                                          Thick gallery wrap (1.5)
                                        </h4>
                                        <p>
                                          Ipsum dolor sit amet,consectetur
                                          adipiscing.
                                        </p>
                                        <p className="box-range">
                                          Starting at +$27.00
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="col-xl-6 col-lg-6 col-md-6 col-sm-12"
                                    style={{ paddingRight: 7 }}
                                  >
                                    <div className="tp-catagori-2__content-box mb-15">
                                      <div className="tp-catagori-2__content plr text-center">
                                        <img
                                          className="w-32"
                                          src="assets/img/blog/edge-3.png"
                                          alt=""
                                        />
                                        <h4 className="tp-catagori-2__title text-white">
                                          Framed canvas
                                        </h4>
                                        <p>
                                          Ipsum dolor sit amet,consectetur
                                          adipiscing.
                                        </p>
                                        <p className="box-range">
                                          Starting at +$35.00
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="col-xl-6 col-lg-6 col-md-6 col-sm-12"
                                    style={{ paddingLeft: 7 }}
                                  >
                                    <div className="tp-catagori-2__content-box mb-15">
                                      <div className="tp-catagori-2__content plr text-center">
                                        <img
                                          className="w-32"
                                          src="assets/img/blog/edge-4.png"
                                          alt=""
                                        />
                                        <h4 className="tp-catagori-2__title text-white">
                                          Rolled in a tube
                                        </h4>
                                        <p>
                                          Ipsum dolor sit amet,consectetur
                                          adipiscing.
                                        </p>
                                        <p className="box-range">No Charge</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
    </>
  )
}
